// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"oO-z","carouselContainer":"pO-z"};